"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.dummyClinicsFromApi = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useTable_1 = __importDefault(require("../../../hooks/useTable"));
var API_1 = require("../../../middleware/API");
var transformAgendaOverview_1 = __importStar(require("../../../middleware/transformAgendaOverview"));
var loginState_1 = require("../../../types/loginState");
var InputSelect_1 = __importDefault(require("../../atoms/InputSelect/InputSelect"));
var Loading_1 = __importDefault(require("../../atoms/Loading/Loading"));
var TablePagination_1 = __importDefault(require("../../molecules/TablePagination/TablePagination"));
var TableView_styles_1 = __importDefault(require("../../styled/TableView.styles"));
var AgendaOverview_styles_1 = __importDefault(require("./AgendaOverview.styles"));
// TO-DO: get from back-end
exports.dummyClinicsFromApi = [
    {
        id: 0,
        date: new Date(),
        coach: 'Duncan Tremel',
        coachSlug: 'duncan-tremel',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: true,
    },
    {
        id: 1,
        date: new Date(),
        coach: 'Sophie Eruz',
        coachSlug: 'sophie-eruz',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 2,
        date: new Date(),
        coach: 'Piet pot',
        coachSlug: 'piet-pot',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 3,
        date: new Date(),
        coach: 'Duncan Tremel',
        coachSlug: 'duncan-tremel',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: true,
    },
    {
        id: 4,
        date: new Date(),
        coach: 'Sophie Eruz',
        coachSlug: 'sophie-eruz',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 5,
        date: new Date(),
        coach: 'Piet pot',
        coachSlug: 'piet-pot',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 6,
        date: new Date(),
        coach: 'Duncan Tremel',
        coachSlug: 'duncan-tremel',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: true,
    },
    {
        id: 7,
        date: new Date(),
        coach: 'Sophie Eruz',
        coachSlug: 'sophie-eruz',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 8,
        date: new Date(),
        coach: 'Piet pot',
        coachSlug: 'piet-pot',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 9,
        date: new Date(),
        coach: 'Duncan Tremel',
        coachSlug: 'duncan-tremel',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: true,
    },
    {
        id: 10,
        date: new Date(),
        coach: 'Sophie Eruz',
        coachSlug: 'sophie-eruz',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 11,
        date: new Date(),
        coach: 'Piet pot',
        coachSlug: 'piet-pot',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: false,
    },
    {
        id: 12,
        date: new Date(),
        coach: 'Duncan Tremel',
        coachSlug: 'duncan-tremel',
        name: 'Titel clinic',
        sport: 'Atletiek',
        type: 'Doorstroom',
        school: 'OBS de Tweemaster',
        cancelled: true,
    },
];
var rowsPerPage = 8;
exports.formatDate = function (date) { return dayjs_1.default(date).locale('nl').format('D MMMM YYYY'); };
var AgendaOverview = function (_a) {
    var loggedIn = _a.loggedIn, username = _a.username;
    var _b = react_1.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(1), page = _c[0], setPage = _c[1];
    var _d = react_1.useState([]), clinics = _d[0], setClinics = _d[1];
    var _e = react_1.useState([]), filteredClinics = _e[0], setFilteredClinics = _e[1];
    var _f = react_1.useState([]), coachOptions = _f[0], setCoachOptions = _f[1];
    var _g = useTable_1.default(filteredClinics, page, rowsPerPage), slice = _g.slice, range = _g.range;
    var onCoachSelect = function (id, value) {
        if (value === 'default') {
            setFilteredClinics(clinics);
        }
        else {
            setFilteredClinics(clinics.filter(function (item) { return item.coachSlug === value; }));
        }
    };
    var navigateToClinic = function (id) {
        window.location.href = "/clinic/" + id;
    };
    react_1.useEffect(function () {
        // get clinics from api, setClinics and set coaches
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.getAgendaOverview()];
                    case 1:
                        data = _a.sent();
                        if (!(data instanceof Error)) {
                            setClinics(transformAgendaOverview_1.default(data.entries));
                            setFilteredClinics(transformAgendaOverview_1.default(data.entries));
                            setCoachOptions(transformAgendaOverview_1.transformCoachesDropdown(data.users));
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    if (isLoading) {
        return react_1.default.createElement(Loading_1.default, null);
    }
    return (react_1.default.createElement(AgendaOverview_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "header" },
                    react_1.default.createElement("h1", { className: "title" }, "Schoolsport agenda"),
                    react_1.default.createElement("div", { className: "secondary" },
                        react_1.default.createElement("p", { className: "description" }, "Onderstaande schoolsport clinics zijn geboekt en bevestigd."),
                        coachOptions.length && coachOptions.length > 2 && clinics.length && clinics.length > 0 ? (react_1.default.createElement(InputSelect_1.default, { label: "Kies voor een sportcoach:", id: "coach", placeholder: "", value: "", options: coachOptions, required: true, valueChanged: onCoachSelect })) : undefined)),
                slice.length && slice.length > 0 ? (react_1.default.createElement("div", { className: "table-wrapper" },
                    react_1.default.createElement(TableView_styles_1.default, null,
                        react_1.default.createElement("table", { className: "table" },
                            react_1.default.createElement("thead", { className: "table-head" },
                                react_1.default.createElement("tr", { className: "table-row" },
                                    react_1.default.createElement("th", null, "Datum"),
                                    coachOptions.length && coachOptions.length > 2 && react_1.default.createElement("th", null, "Sportcoach"),
                                    react_1.default.createElement("th", null, "Naam clinic"),
                                    react_1.default.createElement("th", null, "Sport"),
                                    react_1.default.createElement("th", null, "Soort clinic"),
                                    react_1.default.createElement("th", null, "School"))),
                            react_1.default.createElement("tbody", { className: "table-body" }, slice.map(function (item, index) { return (react_1.default.createElement("tr", { key: index, className: "table-row", onClick: function () { return navigateToClinic(item.id); } },
                                item.cancelled ? (react_1.default.createElement("td", null,
                                    react_1.default.createElement("del", null, exports.formatDate(item.date)),
                                    react_1.default.createElement("span", { className: "cancelled" }, "GEANNULEERD"))) : (react_1.default.createElement("td", null, exports.formatDate(item.date))),
                                coachOptions.length && coachOptions.length > 2 && (react_1.default.createElement("td", null, item.coach)),
                                react_1.default.createElement("td", null, item.name),
                                react_1.default.createElement("td", null, item.sport),
                                react_1.default.createElement("td", null, item.type),
                                react_1.default.createElement("td", null, item.school))); })))),
                    react_1.default.createElement(TablePagination_1.default, { range: range, slice: slice, setPage: setPage, page: page }))) : (react_1.default.createElement("div", { className: "emptyState" },
                    react_1.default.createElement("p", null, "Er zijn geen clinics ingepland voor komend schooljaar 2022 - 2023")))))));
};
exports.default = AgendaOverview;
